import React from "react";
import { TheContentSuperAdmin, TheFooter, TheHeaderSuperAdmin, TheSidebarSuperAdmin } from "./index";

const TheLayoutAdmin = () => {
  return (
    <div className="c-app c-default-layout">
      <TheSidebarSuperAdmin />
      <div className="c-wrapper">
        <TheHeaderSuperAdmin />
        <div className="c-body">
          <TheContentSuperAdmin />
        </div>
        <TheFooter />
      </div>
    </div>
  );
};

export default TheLayoutAdmin;
